
export const common = {
  nav: {
    home: "Home",
    solutions: "Solutions",
    method: "Methodology",
    contemplatedCards: "Contemplated Letters",
    companies: "Corporate",
    contents: "Contents",
    about: "About",
    contact: "Contact",
    diagnostico: "Assessment"
  },
  cta: {
    diagnosis: 'Schedule Strategic Assessment',
    whatsapp: 'WhatsApp: Talk to Specialist',
    primary: 'Schedule Strategic Assessment',
    secondary: 'WhatsApp: Talk to Specialist'
  },
  footer: {
    company: 'FGT Capital',
    location: 'São Paulo/SP – Brazil',
    contact: 'Contact',
    email: 'contato@fgt-capital.com',
    phone: '+55 11 93032-2408',
    solutions: 'Solutions',
    solutionItems: {
      acquisition: 'Real Estate Acquisition',
      construction: 'Construction and Renovation',
      planning: 'Wealth Planning',
      corporate: 'Corporate Structuring',
      letters: 'Contemplated Letters'
    },
    institutional: 'Institutional',
    institutionalItems: {
      method: 'FGT Method',
      business: 'For Companies',
      content: 'Contents',
      about: 'About'
    },
    compliance: 'Contemplation cannot be guaranteed. There is no promise of fixed profitability. Costs and conditions (administration fee and reserve funds) vary according to regulations and administrator.',
    rights: '© 2025 FGT Capital. All rights reserved.',
    copyright: '© 2025 FGT Capital. All rights reserved.',
    privacy: 'Privacy',
    terms: 'Terms'
  }
};
